module.exports = __webpack_public_path__ + "img/icon-data-picker.d12ee7aa.svg";